export default __webpack_public_path__ + "static/media/Doze.ae6d3364.png";